module.exports = __webpack_public_path__ + "img/blaek.04d0418f.png";